import React from 'react';
import { useNavigate } from 'react-router-dom';
import cn from "classnames";
import { replaceSpacesWithHyphens } from '../../../utils/formatPricingNumber';
import styles from "./PastDeals.module.sass";

//const Video = () => {
const PastDealsAssetCard = props => {
    console.debug('PastDealsAssetCard()', props);

    /*
    let videoSrc;
    if (props.filePath) {
        videoSrc = props.filePath
    } else {
        videoSrc = "/videos/" + props.fileName;
    }
    */
    let index = props.index;
    let assetObject = props.assetObject;
    let categoryName = props.categoryName;
    let clickSearchResult = props.clickSearchResult;
    let clickCategory = props.clickCategory;
    const navigate = useNavigate();

    if (assetObject.id == 2) {
        assetObject.asset.pastDealSummary = 'Purchased for $28M, Sold for $46M, ROI 42%';
    } else if (assetObject.id == 3) {
        assetObject.asset.pastDealSummary = 'Purchased for $17.825M, Sold for $30M, ROI 22%';
    } else if (assetObject.id == 4) {
        assetObject.asset.pastDealSummary = 'Purchased for $5.265M, Value today $11.3M, ROI 45%';
    } else if (assetObject.id == 5) {
        assetObject.asset.pastDealSummary = 'Purchased for $10M, Value today $16.5M, ROI 20%';
    }

    return (
        <div
            //className = { styles.slide }
            //className = 'asset-container'
            key = { index }>

            <div
                className = { cn(
                      "item"
                    //, getCategoryName(assetObject?.asset.categoryId)
                    , categoryName
                    , styles.item
                )}

                //onClick = { () => navigate("/search/" + categoryName) }
                //onClick = { () => navigate("/search/" + getCategoryName(assetObject?.asset.categoryId)) }
                //onClick = { () => clickCategory(getCategoryName(assetObject?.asset.categoryId)) }
                onClick = { () => navigate('/item/' + assetObject?.id) }
                style = {{
                    height: '100%'
                    //, maxHeight: '500px'
                    , position: 'relative'
                }}
                >
                <div
                    //className = { categoryName }
                    //className = { cn(categoryName, 'text-shadow') }
                    className = { cn('item-top') }
                    style = {{
                        position: 'absolute'
                        //, top: '-28px'
                        , top: '20px'
                        //, bottom: '-48px'
                        , right: '20px'
                        , margin: '10px'
                        , whiteSpace: 'nowrap'
                    }}>

                    <button
                        className = { cn('flag', categoryName, 'text-shadow') }
                        style = {{
                        //    boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.5)'
                        //    , fontSize: '14px'
                            backgroundColor: 'red'
                            , padding: '10px 20px'
                            , fontSize: '28px'
                            , borderRadius: '8px'
                        }}
                        >
                        { assetObject.status }
                    </button>

                </div>

                {/*
                mediaType = {assetObject?.asset.mediaType}
                <br/>mediaPreviewUrl = {assetObject?.asset.mediaPreviewUrl}
                <img src="images/products/watch-black.png" style = {{ margin: "auto", padding: "0px 18px" }} />
                */}

                {
                    assetObject?.asset.mediaType === "image"
                    &&
                    <img
                        src = { assetObject?.asset.mediaPreviewUrl }
                        style = {{
                        //  margin: "auto",
                        //  width: "100%"
                          //maxHeight: '500px' // not all images are the same size, this ensures that they all align
                          //maxWidth: '600px' // not all images are the same size, this ensures that they all align
                            height: 'auto'
                          //, width: '800px'
                          , width: '100%'
                        }}
                        alt="Avatar"
                        />
                }

                <div
                    //className = { cn('item-bottom') }
                    style = {{
                        display: "flex"
                        //, padding: "16px"
                        , flexBasis: "100%"
                        , flexDirection: 'column'
                        , backgroundColor: '#FFFFFF'
                        , padding: '0px 125px'
                    }}
                    >

                    <div
                        className = { "watch-info-box" }
                        style = {{
                            flexGrow: '0'
                            , flexShrink: '1'
                            , flexBasis: 'auto'
                            , backgroundColor: 'rgba(255,255,255,0.5)'
                            , marginTop: '-220px'
                            , padding: '0px 25px'
                            , borderRadius: '10px'
                            , boxShadow: '0px 0px 10px black'
                        }}
                        >
                        <div>
                            <div
                                //className = { "watch-title" }
                                style = {{
                                    fontSize: '66px'
                                    //, padding: '0px 50px'
                                    , lineHeight: 'unset'
                                    , fontFamily: '"Roboto Slab"'
                                    , textWrap: 'balance'
                                }}
                                >
                                { assetObject?.asset?.name } { assetObject?.asset?.pastDealSummary }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PastDealsAssetCard;
